/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Clock } from 'lucide-react';

const HOURS = Array.from({ length: 24 }, (_, i) => i); // 0..23
const MINUTES = Array.from({ length: 12 }, (_, i) => i * 5); // 0,5,...,55

// Segmented HH:MM duration field (24-hour, no AM/PM) + clock icon — matches the
// DS time selectors used elsewhere. Reads/writes a Date object so it drops into
// existing callers that store the value as a Date.
function DurationSelect({ value, onChange, error }) {
  const date = value instanceof Date && !Number.isNaN(value.getTime()) ? value : null;
  const hasValue = !!date;
  const hours = date ? date.getHours() : 0;
  const minuteRaw = date ? date.getMinutes() : 0;
  const minute = MINUTES.includes(minuteRaw) ? minuteRaw : (Math.round(minuteRaw / 5) * 5) % 60;

  const emit = (h, mm) => {
    const next = date ? new Date(date) : new Date();
    next.setHours(h, mm, 0, 0);
    onChange(next);
  };

  const segCls = 'appearance-none bg-transparent border-0 text-sm text-ink-900 focus:outline-none tabular-nums font-medium cursor-pointer';
  const segStyle = { backgroundImage: 'none', paddingRight: 0 };
  const wrapCls = `flex items-center gap-1 h-10 px-3 border rounded-[8px] bg-white w-full ${error ? 'border-[#CC4525]' : 'border-rule'}`;

  return (
    <div className={wrapCls} style={{ borderStyle: 'solid', boxSizing: 'border-box' }}>
      <select aria-label="Hours" value={hasValue ? hours : ''} onChange={(e) => emit(Number(e.target.value), minute)} className={`${segCls} ${hasValue ? '' : 'text-ink-500'}`} style={segStyle}>
        {!hasValue && <option value="" disabled>HH</option>}
        {HOURS.map((h) => <option key={h} value={h}>{String(h).padStart(2, '0')}</option>)}
      </select>
      <span className={hasValue ? 'text-ink-900 font-medium' : 'text-ink-500 font-medium'}>:</span>
      <select aria-label="Minutes" value={hasValue ? minute : ''} onChange={(e) => emit(hours, Number(e.target.value))} className={`${segCls} ${hasValue ? '' : 'text-ink-500'}`} style={segStyle}>
        {!hasValue && <option value="" disabled>MM</option>}
        {MINUTES.map((mm) => <option key={mm} value={mm}>{String(mm).padStart(2, '0')}</option>)}
      </select>
      <Clock size={16} className="text-ink-500 ml-auto flex-shrink-0" />
    </div>
  );
}

DurationSelect.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

DurationSelect.defaultProps = { value: null, error: false };

export default DurationSelect;
